<template>
  <div>
    <p>
      In everything we do, we aim to bring focus and clarity to teams without distracting, so our logos and symbols are direct, clear and impactful. To accomplish this, we adhere to the guidelines below.
    </p>
    <logos-grid />
    <logos-color />
    <logos-icon />
    <logos-countries />
    <logos-crimes />
  </div>
</template>

<script>
import LogosColor from './logos/LogosColor.vue'
import LogosGrid from './logos/LogosGrid.vue'
import LogosIcon from './logos/LogosIcon.vue'
import LogosCrimes from './logos/LogosCrimes.vue'
import LogosCountries from './logos/LogosCountries.vue'

export default {
  components: {
    LogosColor,
    LogosGrid,
    LogosIcon,
    LogosCrimes,
    LogosCountries,
  },
}
</script>
